module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("系统")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("权限组管理")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus-round"
    },
    on: {
      "click": function($event) {
        return _vm.onEdit('')
      }
    }
  }, [_vm._v("添加分组")])], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/adminGroup/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "onSelection": _vm.onSelection
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑"
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "名称",
      "prop": "title"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "描述",
      "prop": "description"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.description),
      callback: function($$v) {
        _vm.$set(_vm.formData, "description", $$v)
      },
      expression: "formData.description"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.formData.status),
      callback: function($$v) {
        _vm.$set(_vm.formData, "status", _vm._n($$v))
      },
      expression: "formData.status"
    }
  }, _vm._l((_vm.statusList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.editModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEdit
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑权限"
    },
    model: {
      value: (_vm.editPermissionModal),
      callback: function($$v) {
        _vm.editPermissionModal = $$v
      },
      expression: "editPermissionModal"
    }
  }, [_c('el-tree', {
    ref: "permissionTree",
    staticClass: "permission-tree",
    attrs: {
      "data": _vm.permissionData,
      "show-checkbox": "",
      "check-strictly": true,
      "node-key": "id",
      "default-checked-keys": _vm.checkKey
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.editPermissionModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEdit
    },
    on: {
      "click": _vm.editPermission
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "关联知识库"
    },
    model: {
      value: (_vm.kbBindModal),
      callback: function($$v) {
        _vm.kbBindModal = $$v
      },
      expression: "kbBindModal"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#808695",
      "font-size": "12px",
      "margin-bottom": "12px"
    }
  }, [_vm._v("员工仅能问答此处勾选的库；与菜单权限分开。")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "placeholder": _vm.kbBindPlaceholder
    },
    model: {
      value: (_vm.kbBindIds),
      callback: function($$v) {
        _vm.kbBindIds = $$v
      },
      expression: "kbBindIds"
    }
  }, _vm._l((_vm.kbAllBases), function(b) {
    return _c('Option', {
      key: b.id,
      attrs: {
        "value": String(b.id)
      }
    }, [_vm._v(_vm._s(b.name) + " (" + _vm._s(b.externalKbId) + ")")])
  }), 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.kbBindModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.kbBindSaving
    },
    on: {
      "click": _vm.saveKbBind
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-588fdf1e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminGroupList.vue
// module id = 1810
// module chunks = 8